/**
 * Analytics events object keys dictionary
 */
export enum AnalyticsMetaKeys {

    // analytics
    AD_BLOCKER = 'ad_blocker_enabled',
    BRAND = 'brand',
    DOMAIN = 'domain',
    BROWSER = 'browser',
    DIVISION = 'division',
    PAGE_URL = 'page_url',
    PLATFORM = 'platform',
    PLATFORM_VERSION = 'platform_version',
    FEM_VERSION = 'fem_version',
    VIEW_TYPE = 'view_type',
    ENV='env',

    // page
    AD_LIGHT = 'AdLight User',
    ARTICLE_ID = 'article_id',
    ARTICLE_AUTHORS = 'article_authors',
    ARTICLE_AUTHOR_LIST = 'article_author_list',
    ARTICLE_TAGS = 'article_tags',
    ARTICLE_TAG_LIST = 'article_tag_list',
    BROWSER_LG = 'browser_language',
    DEVICE_TYPE = 'device_type',
    ERROR = '404',
    HEADLINE = 'Alternate Headline',
    IS_ORIGINAL = 'originating_property',
    IS_WIRE = 'wire_content',
    MAIN_CATEGORY = 'main_category',
    SECONDARY_CATEGORIES = 'secondary_categories',
    SECONDARY_CATEGORIES_LIST = 'secondary_categories_list',
    META_TAG = 'article_tags',
    METERED_CONTENT = 'metered_content',
    MP_ID = 'MPID',
    NLP_CATEGORY = 'nlp_category',
    NLP_SUB_CATEGORY= 'nlp_sub_category',
    NLP_CATEGORY_LIST = 'nlp_category_list',
    NLP_ENTITY = 'nlp_entity',
    NLP_ENTITY_LIST = 'nlp_entity_list',
    NLP_TOPIC = 'nlp_topic',
    PROJECT_TYPE = 'project_type',
    PUB_TIMESTAMP = 'publish_timestamp',
    REFERRER = 'referrer',
    REF_DETAILS = 'referral_details',
    SESSION_UUID = 'session_uuid',
    SPONSOR_NAME = 'sponsor_name',
    TITLE = 'article_title',
    TYPE = 'page_type',
    USER_STATUS = 'user_status',
    WRD_CNT = 'word_count',
    CHAR_CNT = 'character_count',
    WIRE_AUTHORS = 'wire_authors',
    URL_PARAMS = 'URL Parameters',
    CAR_MAKE = 'car_make',
    CAR_MODEL = 'car_model',
    CAR_YEAR = 'car_year',
    CAR_BODYSTYLE = 'car_bodystyle',
    CAR_CLASSIFICATION = 'car_classification',
    IS_PREMIUM = 'is_premium',

    // Attribute related to scroll events
    PAGEVIEW_PRCNT = 'percentage_of_page_viewed',
    STORYVIEW_PRCNT = 'percentage_of_story_viewed',
    PAGEVIEW_PRCNT_DEPRECATED = 'Percentage of Page Viewed',
    STORYVIEW_PRCNT_DEPRECATED = 'Percentage of Story Viewed',
    PAGEVIEW_INIT_PRCNT = 'Initial Percentage of Page Viewed',

    // Identity
    CUSTOMER_ID = 'customer_id',

    // Click event attributes
    CLICK_SOURCE_VERTICAL_POSITION_PERCENTAGE = 'click_vertical_position_percentage',
    CLICK_SOURCE_VERTICAL_POSITION_PIXELS = 'click_vertical_position_pixels',

    // Custom Flags
    GA_NONINTERACTION = 'Google.NonInteraction',
    GA_PAGE_PATH = 'Google.Page',
    GA_PAGE_TITLE = 'Google.Title'
}
